import { gameCategories, gameRegistry, type GameCategoryId, type GameDefinition } from '../../games/registry';

interface PlanetLayout {
  lat: number;
  lon: number;
  labelX: number;
  labelY: number;
}

const planetLayout: Record<string, PlanetLayout> = {
  'book-of-answering': { lat: 33, lon: -12, labelX: -20, labelY: -8 },
  'instant-astrology': { lat: 18, lon: 6, labelX: 18, labelY: -10 },
  omikuji: { lat: 38, lon: 22, labelX: 22, labelY: -8 },
  'tarot-draw': { lat: 20, lon: 31, labelX: 18, labelY: 8 },
  '24-point': { lat: 16, lon: 75, labelX: -14, labelY: -10 },
  '2048': { lat: 0, lon: 82, labelX: -22, labelY: 6 },
  'german-heart': { lat: -18, lon: 87, labelX: -24, labelY: 10 },
  'memory-flip': { lat: -7, lon: 99, labelX: 20, labelY: -10 },
  minesweeper: { lat: 11, lon: 106, labelX: 20, labelY: -8 },
  'tile-matching': { lat: -8, lon: 114, labelX: 22, labelY: 8 },
  blackjack: { lat: -20, lon: 92, labelX: -24, labelY: 10 },
  'tower-defense': { lat: -28, lon: 119, labelX: 22, labelY: 12 },
  closeit: { lat: 8, lon: -124, labelX: -22, labelY: -10 },
  'mini-autochess': { lat: 24, lon: 96, labelX: -18, labelY: -10 },
  'feed-training': { lat: -27, lon: -104, labelX: 18, labelY: 12 },
  jargon: { lat: 20, lon: -20, labelX: -18, labelY: -10 },
  wordle: { lat: 6, lon: -4, labelX: 18, labelY: 10 },
  'typing-room': { lat: 12, lon: -145, labelX: -18, labelY: -8 },
  'rock-paper-scissors': { lat: -18, lon: 145, labelX: -16, labelY: 8 },
  'five-cards': { lat: -2, lon: 162, labelX: 20, labelY: -10 },
  'boring-box': { lat: -12, lon: -118, labelX: 18, labelY: 10 },
};

const zoneLayout: Record<GameCategoryId, { short: string; lat: number; lon: number; color: string }> = {
  divination: { short: '灵感洲', lat: 28, lon: 8, color: '#d88f82' },
  strategy: { short: '博弈洲', lat: -4, lon: 100, color: '#83c66a' },
  knowledge: { short: '知识洲', lat: 18, lon: -28, color: '#7aa6e6' },
  luck: { short: '幸运洲', lat: -20, lon: 155, color: '#d8a15e' },
  puzzle: { short: '挑战洲', lat: -12, lon: -112, color: '#9b79c6' },
};

export type PlanetGame = GameDefinition & PlanetLayout;

export const planetGames: PlanetGame[] = gameRegistry.map((game) => {
  const layout = planetLayout[game.slug];
  if (!layout) throw new Error(`缺少首页星球坐标：${game.slug}`);
  return { ...game, ...layout };
});

export const planetZones = gameCategories.map((category) => ({
  ...category,
  ...zoneLayout[category.id],
  count: gameRegistry.filter((game) => game.category === category.id).length,
}));

export type PlanetZone = (typeof planetZones)[number];

export function getGame(slug: string) {
  const game = gameRegistry.find((item) => item.slug === slug);
  if (!game) throw new Error(`找不到游戏：${slug}`);
  return game;
}

export const trendingSlugs = ['closeit', 'tower-defense', 'jargon'] as const;
export const trendingGames = trendingSlugs.map((slug) => getGame(slug));
export const trendingRankBySlug = Object.fromEntries(trendingSlugs.map((slug, index) => [slug, index + 1])) as Record<string, number>;
